import React, { useContext, useEffect, useState } from "react";

import { ContactContext as Context, SocialDataContext } from "./index";
import { toast } from "react-toastify";
import {
  alertError,
  alertSuccess,
} from "../../../Shared/Utils/alertMessages.js";
import {
  errorDeleteingData,
  errorGettingData,
  errorUpdatingData,
  genericError,
  successDeleted,
} from "../../../Shared/Constants/index.jsx";
import { getContactsApi } from "../Api/GetContacts.js";
import { createContactApi } from "../Api/CreateContact.js";
import { updateAllContactApi, updateAvatar } from "../Api/UpdateContact.js";
import { deleteContactApi } from "../Api/DeleteContact.js";
import { showContactApi } from "../Api/ShowContact.js";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils.js";
import { exportDataToXls } from "../Api/ExportContactDataToXls.js";
import exportContactDataToXls from "../Services/ExportContactDataToXls.jsx";
import { exportMassiveApi } from "../Api/ExportMassive.js";
import { togleLoading } from "../../../Shared/Utils/alertLoading.js";
import {
  ContactApi,
  SUCCESS_API_RESPONSE,
} from "../../../Shared/Constants/api.js";
import { getCall } from "../../../Shared/Api/GetApi";

const ContactProvider = (props) => {
  const [tableData, setTableData] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAvatar, setLoadingAvatar] = useState(false);

  const [saving, setSaving] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({});
  const [activeButton, setActiveButton] = useState(false); // inndica que el boton de guardar esta activo, es decir, clicable
  const [successUpdated, setSuccessUpdated] = useState(false);
  const [index, setIndex] = useState(0);
  const [firstId, setFirstId] = useState();
  const [lastId, setLastId] = useState();
  const [nextId, setNextId] = useState();
  const [previousId, setPreviousId] = useState();
  const { item: itemSocial, getItem: getItemSocial } =
    useContext(SocialDataContext);
  //para amostrar el mensaje de succes updated
  const modalTogle = () => {
    setModal(!modal);
  };

  const [selectedRows, setSelectedRows] = useState([]);



  //get all item data
  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await showContactApi(id);
      let data = response.data;
      if (response.result === "success") {
        setItem(data);
      } else {
        setItem({});
        alertToastErrorFromResponse(
          "Error obteniendo datos del contacto",
          response
        );
      }
    } catch (error) {
      toast.error("Error desconocido obteniendo datos del contacto !", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setLoading(false);
    }
  };

  //List objects frokm db
  const fetchTableData = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getContactsApi({
        search: searchTerm,
        page: page,
        limit: limit,
        ...filters,
      });
      let data = response.data;

      if (response.result === SUCCESS_API_RESPONSE) {
        setTableData(data.items); // Append new data
        setTotalRows(data.totalRows); // Append new data
        setIndex(0);
      } else {
        setTableData([]); // Append new data
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError("Error fetching data:!");
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createContact = async (data) => {
    setSaving(true);
    let response = await createContactApi(data);

    if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
      setItem(response.data);
      setApiErrors([]);

      setSuccessUpdated(true); //
    } else {
      alertToastErrorFromResponse(genericError, response);
    }
    setSaving(false);
  };

  //edit item
  const updateContact = async (data, id) => {
    setSaving(true);

    let response = await updateAllContactApi(data, id);

    if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
      getItem(id)
      getItemSocial(id)
      setSuccessUpdated(true); //
      setApiErrors([]);
    } else {
      alertToastErrorFromResponse(errorUpdatingData, response);
    }
    setSaving(false);
  };
  //delete item
  const deleteItem = async (id) => {
    let response = await deleteContactApi(id);

    if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
      const newdata = tableData.filter((elem) => {
        return id !== elem.id;
      });
      setTableData(newdata);
      alertSuccess(successDeleted);
      setApiErrors([]);
    } else {
      alertToastErrorFromResponse(errorDeleteingData, response);
    }
  };

  //delete item
  const exportItemData = async (
    item,
    personalData,
    contactData,
    socialData,
    contactEntities,
    asesors
  ) => {
    let response = await exportDataToXls(item?.id);
    if (response?.result && response?.result == "success") {
      exportContactDataToXls(
        item,
        personalData,
        contactData,
        socialData,
        contactEntities,
        asesors
      );
    } else {
      alertToastErrorFromResponse(genericError, response);
    }
  };

  //List objects frokm db
  const exportMassive = async () => {
    togleLoading(true);
    try {
      let response = await exportMassiveApi({
        search: searchTerm,
        ...filters,
      });

      if (response?.result === "error") {
        alertToastErrorFromResponse(errorGettingData, response);
      } else {
        const url = window.URL.createObjectURL(new Blob([response]));
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "contactos.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alertError("Error fetching data !");
    } finally {
      togleLoading(false);
    }
  };

  const handleEdit = async (row) => {
    let editObject = tableData.find((e) => e.id === row.id);
    setItem(editObject);
    setApiErrors([]);
  };

  const getFirstContact = async () => {
    let response = await getCall(`${ContactApi}/first`);
    if (response.result === SUCCESS_API_RESPONSE) {
      setFirstId(response.data);
    }
  };

  const getLastContact = async () => {
    let response = await getCall(`${ContactApi}/last`);
    if (response.result === SUCCESS_API_RESPONSE) {
      setLastId(response.data);
    }
  };

  const getNextContact = async () => {
    let response = await getCall(`${ContactApi}/next/${item.id}`);
    if (response.result === SUCCESS_API_RESPONSE) {
      setNextId(response.data);
    }
  };

  const getPreviousContact = async () => {
    let response = await getCall(`${ContactApi}/previous/${item.id}`);
    if (response.result === SUCCESS_API_RESPONSE) {
      setPreviousId(response.data);
    }
  };

  const getTotalContacts = async () => {
    let response = await getCall(`${ContactApi}/total`);
    if (response.result === SUCCESS_API_RESPONSE) {
      setTotalRows(response.data);
    }
  };

  const selectImageSocialNetwork = async (userName, typeSocialNetwork) => {
    setLoadingAvatar(true);
    let formData = {
      username: userName,
      type: typeSocialNetwork,
      id: item.id
    }
    if (typeSocialNetwork == 'storage') {
      formData = new FormData();
      formData.append("file", userName);
      formData.append("type", "storage");
      formData.append("id", item.id);

    }

    let response = await updateAvatar(formData);
    if (response.result === SUCCESS_API_RESPONSE) {
      setLoadingAvatar(false);
      return response

    }


  }

  return (
    <Context.Provider
      value={{
        ...props,
        tableData,
        deleteItem,
        fetchTableData,
        setCurrentPage,
        setRowsPerPage,
        setLoading,
        apiErrors,
        modalTogle,
        modal,
        setItem,
        item,
        loading,
        currentPage,
        totalRows,
        handleEdit,
        rowsPerPage,
        getItem,
        searchTerm,
        setSearchTerm,
        filters,
        setFilters,
        activeButton,
        setActiveButton,
        setSuccessUpdated,
        successUpdated,
        setApiErrors,
        createContact,
        updateContact,
        setSaving,
        saving,
        exportItemData,
        exportMassive,

        lastId,
        firstId,
        getLastContact,
        getFirstContact,
        nextId,
        previousId,
        getNextContact,
        getPreviousContact,
        index,
        setIndex,
        getTotalContacts,
        selectImageSocialNetwork,
        loadingAvatar,
        setSelectedRows,
        selectedRows
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default ContactProvider;
